<template>
  <button @click="clearCompletedTransfers" :aria-label="$t('sidebar.clearCompletedTransfers')" :title="$t('sidebar.clearCompletedTransfers')" class="action" id="clear-completed-transfers-button">
    <x-icon size="1.5x" class="custom-class"></x-icon>
    <span v-if="isMobile">{{ $t('sidebar.clear') }}</span>
    <span v-else>{{ $t('sidebar.clearCompletedTransfers') }}</span>
  </button>
</template>

<script>

import {mapState} from 'vuex';
import { XIcon } from 'vue-feather-icons';

export default {
  name: 'clear-completed-transfers-button',
  components: {
    XIcon
  },
  computed: {
    ...mapState(['req', 'selected']),
    isMobile () {
      return window.innerWidth <= 768;
    },
  },
  methods: {
    clearCompletedTransfers: async function () {
        if (!this.selected.length) {
          await ibb.clearFinishedTransfersByType(this.req.transferType);
        }
        else {
          let promises = [];
          for (let index of this.selected) {
            promises.push(ibb.clearFinishedTransferByTag(this.req.items[index].tag));
          }

          await Promise.all(promises);
        }

        this.$store.commit('setReload', true);
    }
  }
};
</script>
